// Translations
import benchmarkTransaction from '../components/benchmark-transaction/translations/de'
import billingTransaction from '../components/billing-transaction/translations/de'
import finetuneTransaction from '../components/finetune-transaction/translations/de'
import modelTransaction from '../components/model-transaction/translations/de'
import pipelineTransaction from '../components/pipeline-transaction/translations/de'
import serviceTransaction from '../components/service-transaction/translations/de'
import transferTransaction from '../components/transfer-transaction/translations/de'

// Translation: Account > Billing > Transactions (German)
export default Object.freeze({
	components: { benchmarkTransaction, billingTransaction, finetuneTransaction, modelTransaction, pipelineTransaction, serviceTransaction, transferTransaction },
	fallback: {
		empty: '',
		unavailable: ''
	},
	title: ''
})
